import { FC } from 'react';
import { Text, Button, Tooltip, Icon } from '@livechat/design-system-react-components';

import { getLogoSource } from 'helpers/logo';

import * as styles from './styles';

type Props = {
  product: string;
};

export const InaccessibleProductButton: FC<Props> = ({ product }) => (
  <Tooltip
    triggerRenderer={() => (
      <Button
        kind="secondary"
        css={styles.goToProductButton('secondary')}
        disabled
        data-testid={`inaccessible-product-button-${product.toLowerCase()}`}
      >
        <Icon source={getLogoSource(product)} />
        <Text bold css={styles.goToProductButtonText(true)}>
          No access to {product}
        </Text>
      </Button>
    )}
    kind="invert"
    placement="bottom"
  >
    <Text>
      This organization already uses {product}. Ask {product} Admin to invite you.
    </Text>
  </Tooltip>
);
